import useTranslations from '@/hooks/useTranslations';
import Button from '@mui/material/Button';
import EastRoundedIcon from '@mui/icons-material/EastRounded';

export default function LoginButton({
  isMobile,
  onClose,
}: {
  isMobile: boolean;
  onClose: () => void;
}) {
  const { t, locale } = useTranslations();

  return (
    <Button
      variant='text'
      color='secondary'
      href={`https://platform.orthosolid.com/${locale}`}
      target='_blank'
      className='rounded'
      endIcon={<EastRoundedIcon />}
      onClick={onClose}
      fullWidth={isMobile}
    >
      {t('changePassword.login')}
    </Button>
  );
}
